import { KText } from '@/ui-library/components/text';
import { Flex } from '@chakra-ui/react';
import { components } from 'react-select';
import DOMPurify from 'dompurify';

export const VonqSelectOption = (props) => {
  const { data } = props;
  const label = data?.label;
  const desc = data?.desc; // Description from VONQ data

  return (
    <components.Option {...props}>
      <Flex direction="column" gap="2px">
        <KText size="sm-medium" color="secondary-900">
          {label}
        </KText>
        {desc && (
          <KText color="secondary-700" size="xs-regular">
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(desc) }} />
          </KText>
        )}
      </Flex>
    </components.Option>
  );
};